export const isProductAvailable = (product) => product.availability === 'available' &&
    Number.isSafeInteger(product.priceMinor) &&
    product.priceMinor >= 0;
